import React, { useState } from "react";
import { MapPin, Zap, CalendarDays, Users, ChevronRight, LayoutGrid } from "lucide-react";
import { Button } from "@/components/ui/button";
import QuizModal from "@/components/QuizModal";

const CollectionIntroSection: React.FC = () => {
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  const openQuiz = () => setIsQuizOpen(true);
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-8 py-6 lg:py-10">
      <div className="max-w-5xl mx-auto rounded-2xl border border-border hover:border-cta-green shadow-lg hover:shadow-[0_8px_30px_-4px_hsl(var(--cta-green)/0.35)] transition-all duration-300 relative overflow-hidden" style={{ backgroundImage: "url('/lovable-uploads/villa-st-tropez-quiz-bg.webp')", backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-black/40" />
        
        <div className="relative z-10 p-10 md:p-16 flex flex-col items-center text-center space-y-5">
          {/* Badge */}
          <button onClick={openQuiz} className="inline-flex items-center gap-2 rounded-full bg-cta-green px-4 py-1.5 text-xs font-semibold tracking-widest text-cta-green-foreground uppercase cursor-pointer hover:bg-cta-green/90 transition-colors">
            <Zap className="h-3.5 w-3.5 fill-current animate-bounce" />
            Quiz
          </button>

          {/* Title */}
          <h1 className="text-2xl md:text-4xl text-white tracking-tight text-balance leading-tight font-semibold drop-shadow-md">
            Trouvez la destination idéale pour votre événement
          </h1>

          {/* Subtitle */}
          <p className="text-sm md:text-base text-white max-w-xl drop-shadow-sm">
            Répondez à quelques questions rapides et nous vous proposerons le lieu idéal pour votre prochain événement
          </p>

          {/* Step indicators */}
          <div className="hidden md:flex items-center gap-3 text-sm text-white drop-shadow-sm">
            <button onClick={openQuiz} className="flex items-center gap-1.5 hover:text-white transition-colors cursor-pointer">
              <LayoutGrid className="h-4 w-4 text-cta-green" />
              Type d'événement
            </button>
            <ChevronRight className="h-4 w-4 text-white" />
            <button onClick={openQuiz} className="flex items-center gap-1.5 hover:text-white transition-colors cursor-pointer">
              <CalendarDays className="h-4 w-4 text-cta-green" />
              Dates
            </button>
            <ChevronRight className="h-4 w-4 text-white" />
            <button onClick={openQuiz} className="flex items-center gap-1.5 hover:text-white transition-colors cursor-pointer">
              <Users className="h-4 w-4 text-cta-green" />
              Participants
            </button>
            <ChevronRight className="h-4 w-4 text-white" />
            <button onClick={openQuiz} className="flex items-center gap-1.5 hover:text-white transition-colors cursor-pointer">
              <MapPin className="h-4 w-4 text-cta-green" />
              Votre match
            </button>
          </div>

          {/* CTA */}
          <Button
            onClick={openQuiz}
            className="bg-cta-green hover:bg-cta-green/90 text-cta-green-foreground rounded-xl font-semibold px-4 py-2 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-cta-green/30">
            Démarrer
          </Button>

          {/* Sub-text */}
          <p className="text-xs text-white drop-shadow-sm">Résultat en moins d'une minute</p>
        </div>
      </div>

      <QuizModal isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
    </section>);
};

export default CollectionIntroSection;